import { Box, Typography, Stack, IconButton } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const PortfolioPanel = ({
  title,
  count,
  value,
  change,
  isPositive,
  percentage,
  color,
  onClick,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: "#13172a",
        borderRadius: "16px",
        px: 2.5,
        py: 1.25,
        mb: 2,
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        border: "1px solid rgba(255, 255, 255, 0.06)",
        // "&:hover": {
        //   backgroundColor: "#1c2342",
        //   borderColor: "rgba(56, 189, 248, 0.2)",
        //   transform: "translateY(-2px)",
        //   boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
        // },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
      >
        <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            fontWeight="700"
            color="white"
            sx={{
              fontSize: { xs: "17px", md: "19px" },
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              letterSpacing: "0.2px",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontSize: { xs: "12px", md: "13px" },
              color: "rgba(255, 255, 255, 0.5)",
              fontWeight: 400,
            }}
          >
            {count} {typeof count === "number" ? "Brokers" : ""}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={{ xs: 1, md: 3 }} alignItems="center">
          <Stack alignItems="flex-end" spacing={0} sx={{ minWidth: { xs: "100px", md: "150px" } }}>
            <Typography
              variant="subtitle1"
              fontWeight="700"
              sx={{
                color: "#38bdf8",
                fontSize: { xs: "16px", md: "20px" },
                letterSpacing: "0.5px",
                fontFamily: "'Outfit', sans-serif",
                textAlign: "right"
              }}
            >
              {typeof value === "number"
                ? `₹${value.toLocaleString("en-IN")}`
                : `₹${value}`}
            </Typography>
            {change !== undefined && change !== null && !isNaN(parseFloat(change)) && (
              <Stack direction="row" alignItems="center" spacing={0.2} justifyContent="flex-end">
                {parseFloat(change) !== 0 && (
                  isPositive ? (
                    <ArrowDropUpIcon
                      sx={{ fontSize: { xs: 18, md: 22 }, color: "#10B981" }}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      sx={{ fontSize: { xs: 18, md: 22 }, color: "#EF4444" }}
                    />
                  )
                )}
                <Typography
                  variant="caption"
                  fontWeight="600"
                  sx={{
                    color: (change === "0" || parseFloat(String(change).replace(/[₹,]/g, "")) === 0) ? "#fff" : (isPositive ? "#10B981" : "#EF4444"),
                    fontSize: { xs: "11px", md: "13px" },
                  }}
                >
                  {Math.abs(parseFloat(change))}%
                </Typography>
              </Stack>
            )}
          </Stack>
          <Box
            sx={{
              width: { xs: 32, md: 36 },
              height: { xs: 32, md: 36 },
              borderRadius: "50%",
              border: "1.5px solid rgba(56, 189, 248, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "rgba(56, 189, 248, 0.1)",
                borderColor: "#38bdf8",
                transform: "rotate(-10deg) scale(1.05)",
              },
            }}
          >
            <ChevronRight
              sx={{ color: "#38bdf8", fontSize: { xs: 20, md: 22 } }}
            />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default PortfolioPanel;
